import {BooleanResult, MethodCategoriesEnum, StaticallyTypedMethod} from './internal';

export class BooleanMethod extends StaticallyTypedMethod {
  constructor(category: MethodCategoriesEnum) {
    super(category, BooleanResult);
  }
}
